import * as React from 'react';
import { useSelector } from 'react-redux';
import { TAreaInputComponentProps } from 'shared/common/utils/types';
import { selectFormFields, selectEstimationTarget } from '../../selectors';
import { useActions } from '../useActions';
import { ECurrentErrorField, EUnits } from '../../types/formFields';
import { getTrackMyHomeLandAreaPick } from '../tracking';
import { intOnly } from '../../utils/intOnly';

/** Пропсы для фильтра площади дома */
export const useLandAreaInputProps = (): TAreaInputComponentProps => {
  const { landArea, errorTooltip, userSetArea } = useSelector(selectFormFields);
  const estimationTarget = useSelector(selectEstimationTarget);

  const { setError, setUserAreaFlag, setLandArea } = useActions();

  /** Если есть ошибка, отобразится над инпутом фильтра */
  const errorMessage = errorTooltip.currentErrorField === ECurrentErrorField.landArea ? errorTooltip.errorText : '';

  /** Обработчик ввода в инпут Площади */
  const onValueChange = React.useCallback<TAreaInputComponentProps['onValueChange']>(
    value => {
      const intVal = intOnly(value);

      setLandArea(Number(intVal));

      if (!userSetArea) {
        setUserAreaFlag(true);
      }

      if (errorMessage) {
        setError({ currentErrorField: ECurrentErrorField.landArea, errorText: '' });
      }
    },
    [errorMessage, userSetArea, setLandArea, setError, setUserAreaFlag],
  );

  return {
    value: landArea ? String(landArea) : '',
    unit: EUnits.sotki,
    errorMessage,
    onValueChange,
    onBlur: getTrackMyHomeLandAreaPick(estimationTarget),
    shouldShowUnit: true,
    placeholder: '10',
  };
};
